export default __webpack_public_path__ + "static/media/eventresult.99863a7f.svg";